import React from 'react'

const Facebook = (props) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={props ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props ? props.opacity : '0.5'}>
            <path
                d="M11.25 5.15625H8.4375V3.28125C8.4375 2.76375 8.8575 2.34375 9.375 2.34375H10.3125V0H8.4375C6.88406 0 5.625 1.25906 5.625 2.8125V5.15625H3.75V7.5H5.625V15H8.4375V7.5H10.3125L11.25 5.15625Z"
            />
        </g>
    </svg>
)

export default Facebook
